import { BehaviorSubject } from 'rxjs'

/** Runtime app config loaded from `/assets/configuration.json` before bootstrap. */
export const baseConfig = new BehaviorSubject<any>('')
